<script lang="ts">
    import type { Slider } from '@shared/types/types';

    let { sliderType }: Slider = $props();
</script>

<div
    class={{
        reptile_slider__container: true,
        'reptile_slider__container--blackfriday': sliderType === 'RATING_BLACK_FRIDAY',
    }}
    data-type={sliderType}
></div>
